import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { TabView, TabPanel } from "primereact/tabview";
import { Image } from "primereact/image";
import { FaCheck } from "react-icons/fa6";
import { Dialog } from "primereact/dialog";
import Slider from "@mui/material/Slider";
import useStoreCarPlan from "../../../store/actions/store-car-plan-quote";
import prettyGirlCS from "../../../assets/images/pretty-girl-client-servicing.png";
import serviceCallerFemale from "../../../assets/images/service-caller-female.png";
import infoIcon from "../../../assets/images/vehicle-not-supported-info.png";
import Loader2 from "../../../components/Loader2";

import useGetCarQuoteList from "../../../store/selectors/get-car-quote-list";
import "../../../assets/styles/sticky-bottom.css";
import "../../../assets/styles/mui-slider.css";
import "../../../assets/styles/select-car-plan.css";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import useStoreVehicleInfo from "../../../store/actions/store-vehicle-info";
import useStoreCarAddOnSelection from "../../../store/actions/store-car-add-on-selection";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useStoreToken from "../../../store/actions/store-token";
import useGetToken from "../../../store/selectors/get-token";
import {
	getAppSettings,
	getMoreQuotes,
	getOrder,
	getQuoteRequest,
	getQuotes,
	startQuoteSession,
	getQuoteSessionStatus,
	getRenewal,
	viewPolicy,
} from "../../../utils/backend";
import useStoreCarPlanList from "../../../store/actions/store-car-quote-list";
import useStoreOrderId from "../../../store/actions/store-order-id";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";
import submitSuccessFul from "../../../assets/images/submit-successful.png";
import submitFail from "../../../assets/images/submit-failed.png";

import useStoreCarAddOn from "../../../store/actions/store-car-add-on";
import useStoreCarQuoteList from "../../../store/actions/store-car-quote-list";
import useStoreCarPlanQuote from "../../../store/actions/store-car-plan-quote";

import aiaGeneral from "../../../assets/images/insurance/aia-general.png";
import aigMalaysia from "../../../assets/images/insurance/aig-malaysia.png";
import allianz from "../../../assets/images/insurance/allianz.png";
import berjayaSompo from "../../../assets/images/insurance/berjaya-sompo.png";
import chubb from "../../../assets/images/insurance/chubb.png";
import etiqaGeneral from "../../../assets/images/insurance/etiqa-general.png";
import etiqaTakaful from "../../../assets/images/insurance/etiqa-takaful.png";
import generali from "../../../assets/images/insurance/generali.png";
import greatEastern from "../../../assets/images/insurance/great-eastern.png";
import liberty from "../../../assets/images/insurance/liberty-insurance.png";
import lonpac from "../../../assets/images/insurance/lonpac-insurance.png";
import msig from "../../../assets/images/insurance/msig-insurance.png";
import pacific from "../../../assets/images/insurance/pacific-insurance.png";
import pacificOrient from "../../../assets/images/insurance/pacific-orient.jpg";
import qbeMalaysia from "../../../assets/images/insurance/qbe-malaysia.png";
import rhb from "../../../assets/images/insurance/rhb-insurance.png";
import takafulIkhlas from "../../../assets/images/insurance/takaful-ikhlas.png";
import takafulGeneral from "../../../assets/images/insurance/takaful-insurance.png";
import tokioMarine from "../../../assets/images/insurance/tokio-marine.png";
import tuneProtect from "../../../assets/images/insurance/tune-protect.png";
import zurichGeneral from "../../../assets/images/insurance/zurich-general.png";
import zurichTakaful from "../../../assets/images/insurance/zurich-takaful-new.png";
import ansaLogo from "../../../assets/images/logo/ansa-logo-default.png";
import { getInsurerName } from "../../../utils/insurer-name";
import UnderwriterDisclosure from "../../../components/UnderwriterDisclosure";
import AppOnlyNotice from "../../../components/AppOnlyNotice";

import { useTranslation } from "react-i18next";
import { Checkbox } from "@mui/material";

const SelectCarPlan = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [loader2, setLoader2] = useState(false);
	const [loadPlans, setLoadPlans] = useState(false);
	// Progressive quotes: true from the first card until the session completes; drives the
	// "fetching more quotes" hint while cards keep arriving.
	const [loadingMore, setLoadingMore] = useState(false);
	// Supersedes an in-flight progressive poll loop when a newer quote fetch starts (or the
	// component unmounts) so stale results never overwrite fresh ones.
	const quoteRunRef = useRef(0);
	const [plan, setPlan] = useState("");
	const [plans, setPlans] = useState([]);
	const [isMoreQuoatation, setIsMoreQuoatation] = useState(true);
	// Admin-controlled toggle (app_settings.request_more_quotation_enabled);
	// hidden until the flag is fetched, shown on fetch failure (legacy behavior)
	const [moreQuoteEnabled, setMoreQuoteEnabled] = useState(false);
	const navigate = useNavigate();
	const storeToken = useStoreToken();
	const token = useGetToken();
	// Quotes are login-only (Ansa-Support#137). The app's renewal links bring ?token= before it is
	// stored, so count that as a session too. A 401 while quoting is a session that has since
	// expired (the app's token lives 45 minutes): say so instead of "no quote found".
	const [searchParams] = useSearchParams();
	const hasAppSession = Boolean(token || searchParams.get("token"));
	const [sessionExpired, setSessionExpired] = useState(false);
	const isUnauthorized = (res) => res?.status_code === 401 || res?.response?.status === 401;
	const [policyId, setPolicyId] = useState("");
	const storeCarPlan = useStoreCarPlan();
	const getCarQuoteList = useGetCarQuoteList();
	const vehicleInfo = useGetVehicleInfo();
	const setVehicleInfo = useStoreVehicleInfo();
	const setAddOnSelection = useStoreCarAddOnSelection();
	const setCarQuoteList = useStoreCarPlanList();
	const storeOrderId = useStoreOrderId();
	const getCarPlan = useGetCarPlan();

	const [activeTabIndex, setActiveTabIndex] = useState(0);
	const [selectedProviders, setSelectedProviders] = useState([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
	const [isReqMoreQuoteVisible, setIsReqMoreQuoteVisible] = useState(false);
	const [tagsVisible, setTagsVisible] = useState(false);
	const [tempPriceRange, setTempPriceRange] = useState([0, 0]);
	const [priceRange, setPriceRange] = useState([0, 0]);
	const [tempSelectedValueType, setTempSelectedValueType] = useState("");
	const [sortByPrice, setSortByPrice] = useState("lowestToHighest");
	const [selectedValueType, setSelectedValueType] = useState("");
	const [quoteSelected, setQuoteSelected] = useState(0);
	const [selectedInsurers, setSelectedInsurers] = useState([]);
	const [ncdPercent, setNcdPercent] = useState(0);

	const [selectedSumInsured, setSelectedSumInsured] = useState(0);
	const [marketValueRange, setMarketValueRange] = useState([0, 0]);
	const [agreeValueRange, setAgreeValueRange] = useState([0, 0]);

	const [enableSumInsuredFilter, setEnableSumInsuredFilter] = useState(false);

	useEffect(() => {
		getAppSettings().then((settings) => {
			setMoreQuoteEnabled(settings?.request_more_quotation_enabled !== false);
		});
	}, []);

	useEffect(()=> {
		if (plans.length === 0) return;

		console.log({plans})

		let minMarketValue= Infinity;
		let maxMarketValue= 0;

		let minAgreeValue= Infinity;
		let maxAgreeValue= 0;

		let suminsured = null

		for (const plan of plans) {
			const { min_market_value, max_market_value, min_agreed_value, max_agreed_value } = plan;

			console.log({min_market_value, max_market_value, min_agreed_value, max_agreed_value})

			if (plan.min_market_value) {
				minMarketValue = Math.min(minMarketValue, parseFloat(plan.min_market_value));
			}
			if (plan.max_market_value) {
				maxMarketValue = Math.max(maxMarketValue, parseFloat(plan.max_market_value));
			}

			if (plan.min_agreed_value) {
				minAgreeValue = Math.min(minAgreeValue, parseFloat(plan.min_agreed_value));
			}
			if (plan.max_agreed_value) {
				maxAgreeValue = Math.max(maxAgreeValue, parseFloat(plan.max_agreed_value));
			}
			if (plan.sum_insured) {
				suminsured = parseFloat(plan.sum_insured);
			}
		}

		console.log({minAgreeValue, maxAgreeValue, minMarketValue, maxMarketValue})

		if (!selectedSumInsured) {
			setSelectedSumInsured(suminsured || minMarketValue);
		}
		if (!marketValueRange[0]) {
			setMarketValueRange([minMarketValue || 0, maxMarketValue]);
		}
		if (!agreeValueRange[0]) {
			setAgreeValueRange([minAgreeValue || 0, maxAgreeValue]);
		}
	}, [plans])

	const [isRecon, setIsRecon] = useState(() => {
		const cachedVariant = localStorage.getItem("isReconditioned");
		return cachedVariant ? cachedVariant === "true" : false;
	});

	const [filter, setFilter] = useState({
		selectedProviders: [],
		priceRange: [0, 99999],
		valueType: "",
		sortByPrice: "lowestToHighest",
		enableSumInsuredFilter: false,
		sumInsured: undefined
	});

	const [offsetHeight, setOffsetHeight] = useState(0);

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);

	const { t } = useTranslation();

	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const [image, setImage] = useState(submitSuccessFul);
	const [dialogTitle, setDialogTitle] = useState("");
	const [respMessage, setRespMessage] = useState("");
	const [dialogOpen, setDialogOpen] = useState(false);

	const clearVehicleInfo = useStoreVehicleInfo();
	const clearCarAddOn = useStoreCarAddOn();
	const clearCarAddOnSelection = useStoreCarAddOnSelection();
	const clearCarQuoteList = useStoreCarQuoteList();
	const clearCarPlanQuote = useStoreCarPlanQuote();

	const getDOBFromId = (idNo) => {
		const regex = /^(\d{6})\d{2}\d{3}(\d{1})$/;
		const match = idNo.match(regex);

		if (!match) {
			throw new Error(t(`messages.invalidIdNumberFormat`));
		}

		const birthDate = match[1];
		const genderDigit = parseInt(match[2], 10);

		const yearPrefix = birthDate.substring(0, 2);
		const month = birthDate.substring(2, 4);
		const day = birthDate.substring(4, 6);

		const currentYear = new Date().getFullYear();
		const currentCentury = Math.floor(currentYear / 100) * 100;

		let fullYear;

		if (parseInt(yearPrefix, 10) <= currentYear % 100) {
			fullYear = `20${yearPrefix}`;
		} else {
			fullYear = `19${yearPrefix}`;
		}

		const dob = new Date(`${fullYear}-${month}-${day}`);

		const age = currentYear - dob.getFullYear();

		if (isNaN(dob) || age < 0 || age > 120) {
			throw new Error(t(`messages.invalidBirthYearInIdNumber`));
		}

		const gender = genderDigit % 2 === 0 ? "F" : "M";

		const formattedDob = dob.toISOString().split("T")[0];

		return {
			dob: formattedDob,
			gender: gender,
			age: age,
		};
	};

	useEffect(() => {
		if (getCarPlan) {
			setPlan(getCarPlan);
		}

		fetchPolicyDetails();
	}, [getCarPlan]); // Runs when getCarPlan updates

	const [selectedVariant, setSelectedVariant] = useState(() => {
		const cachedVariant = localStorage.getItem("selectedVariant");
		return cachedVariant ? JSON.parse(cachedVariant) : null;
	});

	const viewMyRequest = (e) => {
		e.preventDefault();
		window.ReactNativeWebView.postMessage("viewPolicies");
	};

	const handleBackButton = (e) => {
		e.preventDefault();
		window.ReactNativeWebView.postMessage("closeWebView");
	};

	// Bump the run id on unmount so any in-flight poll loop stops touching state.
	useEffect(() => {
		return () => {
			quoteRunRef.current += 1;
		};
	}, []);

	// Progressive quote fetch: start a session then poll it, rendering insurer cards as
	// each one prices instead of blocking on the slowest of ~11. Falls back to the legacy
	// one-shot batch getQuotes if the session endpoints are absent (older backend) or the
	// start call fails. Owns loadPlans/loadingMore; resolves when the session completes.
	// opts.onResults(cards, { complete }) — optional. When provided, the caller renders the
	//   cumulative card set itself (e.g. to merge with an order's existing manual quotations).
	// opts.sessionId — optional. Poll an EXISTING session (handed over from the variant page)
	//   instead of starting a new one.
	// opts.onFlag(flag) — optional. Called on an owner-mismatch / policy-not-yet-due short-
	//   circuit ("is_wrong_owner" | "is_more_than_2_months") instead of rendering no cards.
	const runProgressiveQuotes = async (tkn, payloads, opts = {}) => {
		const applyResults =
			typeof opts.onResults === "function" ? opts.onResults : null;
		const onFlag = typeof opts.onFlag === "function" ? opts.onFlag : null;
		const runId = ++quoteRunRef.current;
		const isStale = () => quoteRunRef.current !== runId;

		setLoadPlans(true);
		setLoadingMore(false);
		if (!applyResults) setPlans([]);

		const render = (cards, complete) => {
			if (applyResults) applyResults(cards, { complete });
			else {
				setPlans(cards);
				if (complete) setCarQuoteList(cards);
			}
		};

		// A consumed cross-page session handle must not re-trigger on remount.
		const clearSessionHandle = () => {
			try {
				localStorage.removeItem("quote_session_id");
				localStorage.removeItem("quote_session_payload");
			} catch (e) {}
		};

		const handleFlag = (flag) => {
			clearSessionHandle();
			if (onFlag) onFlag(flag);
			else render([], true);
			setLoadingMore(false);
		};

		const legacyBatch = async () => {
			const getQuote = await getQuotes(tkn, payloads);
			if (isStale()) return;
			if (isUnauthorized(getQuote)) {
				setSessionExpired(true);
				return;
			}
			if (getQuote && getQuote.success) {
				const data = getQuote.data;
				// Preserve the owner-mismatch / not-yet-due guard on the batch fallback.
				if (data && (data.is_wrong_owner || data.is_more_than_2_months)) {
					handleFlag(data.is_wrong_owner ? "is_wrong_owner" : "is_more_than_2_months");
					return;
				}
				render(Array.isArray(data) ? data : [], true);
			}
		};

		try {
			let sessionId = opts.sessionId || null;

			if (!sessionId) {
				const started = await startQuoteSession(tkn, payloads);
				if (isStale()) return;
				// The batch fallback would only be refused the same way.
				if (isUnauthorized(started)) {
					setSessionExpired(true);
					return;
				}
				// No session support / start failed -> legacy behaviour, no regression.
				if (
					!started ||
					!started.success ||
					!started.data ||
					!started.data.session_id
				) {
					await legacyBatch();
					return;
				}
				sessionId = started.data.session_id;
			}

			const POLL_MS = 1200;
			const MAX_POLLS = 40; // ~48s hard stop even if the server never says "complete"

			for (let i = 0; i < MAX_POLLS; i++) {
				const status = await getQuoteSessionStatus(tkn, sessionId);
				if (isStale()) return;

				if (isUnauthorized(status)) {
					clearSessionHandle();
					setSessionExpired(true);
					return;
				}

				// A handed-over session that no longer exists (expired / restart) -> fall back
				// to a one-shot batch so the user still gets quotes.
				if (opts.sessionId && status && status.success === false) {
					clearSessionHandle();
					await legacyBatch();
					return;
				}

				if (status && status.success && status.data) {
					const d = status.data;
					if (d.is_wrong_owner || d.is_more_than_2_months) {
						handleFlag(d.is_wrong_owner ? "is_wrong_owner" : "is_more_than_2_months");
						return;
					}

					const results = Array.isArray(d.results) ? d.results : [];
					const complete = d.status === "complete";
					render(results, complete);
					if (results.length > 0) {
						setLoadPlans(false); // reveal cards; keep the "more" hint below
						setLoadingMore(!complete);
					}
					if (complete) {
						clearSessionHandle();
						setLoadingMore(false);
						return;
					}
				}
				await new Promise((r) => setTimeout(r, POLL_MS));
			}
			// Poll cap hit without "complete": leave whatever arrived, drop the spinner.
			clearSessionHandle();
			setLoadingMore(false);
		} finally {
			if (!isStale()) setLoadPlans(false);
		}
	};

	const handleValueTypeChange = async (valueType, sumInsured) => {
		setLoadPlans(true);
		try {
			const id_data = vehicleInfo?.id_no ? getDOBFromId(vehicleInfo.id_no) : {};

			//console.log("THIS IS VEHICLE INFO: ,", vehicleInfo);

			let today = new Date();

			let issue_date = today.toISOString().split("T")[0];

			const payloads = {
				usecode: "",
				id_type: vehicleInfo.id_type,
				id_no: vehicleInfo.id_no,
				veh_reg_no: vehicleInfo.reg_no,
				postcode: vehicleInfo.postcode,
				veh_type: vehicleInfo.veh_type,
				adddriver: [],
				policy_holder_name: vehicleInfo.owner_name,
				ownership_type: vehicleInfo.ownership_type,
				gender_code: id_data?.gender || "",
				marital_code: vehicleInfo.marital_status,
				dob: id_data?.dob || "",
				address1: "",
				address2: "",
				driveexp: "",
				occupation: "M36",
				cover_note_cate: "NWOO",
				issue_date: issue_date,
				inception_date: vehicleInfo.effective_date,
				expiry_date: vehicleInfo.expiry_date,
				class_code: vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				vehicle_class_code:
					vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				coverage_code: "CO",
				vehicle_use: "Q3",
				make_code: vehicleInfo?.vehicle_details?.make_code || "",
				model_code: vehicleInfo?.vehicle_details?.model_code || "",
				capacity: vehicleInfo?.vehicle_details?.veh_capacity || "",
				uom: "CC",
				make_year: vehicleInfo?.vehicle_details?.make_year || "",
				seats: selectedVariant?.variant_seat || "",
				ncd_from_code: "",
				engine_no: vehicleInfo?.vehicle_details?.engine_no || "",
				chassis_no: vehicleInfo?.vehicle_details?.chassis_no || "",
				nvic_code: selectedVariant?.variant_nvic || "",
				sum_insured: sumInsured,
				email: "",
				hphoneno: "",
				msv_plan_code: "",
				extra_coverages: [],
				...(valueType === "market" ? { market_value: true } : {}),
				...(valueType === "agree" ? { agree_value: true } : {}),
				vehicle_variant: `${selectedVariant?.variant_name} ${selectedVariant?.variant_transmission} (${selectedVariant.variant_capacity}cc)`,
				isRecon: isRecon,
			};

			//console.log(payloads);

			// Call the quotes API progressively (cards render as each insurer prices).
			setPlan("");
			await runProgressiveQuotes(token, payloads);
		} catch (error) {
			showErrorMessage("Something went wrong while fetching quotes");
			setLoadPlans(false);
			setLoadingMore(false);
		}
	};

	const manualInsurersMapping = [
		{ insurer_name: "RHBI", insurer_fullname: "RHB INSURANCE BERHAD" },
		{ insurer_name: "GENERALI", insurer_fullname: "GENERALI INSURANCE BERHAD" },
		{ insurer_name: "BERJAYA SOMPO", insurer_fullname: "BERJAYA SOMPO INSURANCE BERHAD" },
		{ insurer_name: "TOKIO MARINE", insurer_fullname: "TOKIO MARINE INSURANCE (MALAYSIA) BERHAD" },
		{ insurer_name: "LIBERTY", insurer_fullname: "LIBERTY GENERAL INSURANCE BERHAD" },
		{ insurer_name: "TAKAFUL IKHLAS", insurer_fullname: "TAKAFUL IKHLAS GENERAL BERHAD" },
		{ insurer_name: "LONPAC", insurer_fullname: "LONPAC INSURANCE BERHAD" },
		{ insurer_name: "TUNE PROTECT", insurer_fullname: "TUNE INSURANCE MALAYSIA BERHAD" },
		{ insurer_name: "ETIQA", insurer_fullname: "ETIQA GENERAL INSURANCE BERHAD" },
		{ insurer_name: "ALLIANZ", insurer_fullname: "ALLIANZ GENERAL INSURANCE COMPANY (MALAYSIA) BERHAD" }
	];

	const fetchPolicyDetails = async () => {
		setLoading(true);
		// Clear add-ons when entering this screen
		const queryParameters = new URLSearchParams(window.location.search);
		const tokenParam = queryParameters.get("token");
		const policyId = queryParameters.get("policy_id");
		const orderId = queryParameters.get("order_id");

		if (tokenParam && policyId) {
			clearCarPlanQuote(null);

			storeToken(tokenParam);
			setPolicyId(policyId);

			try {
				const policyDetails = await viewPolicy(tokenParam, { id: policyId });
				const policyData = policyDetails?.data || {};
				const motorInsurance = policyData?.motor_insurance || {};

				let id_data;
				if (
					(motorInsurance.id_type === "nric" ||
						motorInsurance.id_type === "NRIC") &&
					motorInsurance.id_no
				) {
					id_data = getDOBFromId(motorInsurance.id_no);
				}

				const today = new Date(policyDetails?.policy_end_date || new Date());
				today.setHours(today.getHours() + 32);

				const inception_date = today.toISOString().split("T")[0];
				const expiry_date = new Date(today);
				expiry_date.setFullYear(expiry_date.getFullYear() + 1);
				expiry_date.setDate(expiry_date.getDate() - 1);

				setVehicleInfo({
					owner_name: motorInsurance?.owner_name || "",
					insurer_name: motorInsurance?.insurer_name || "",
					effective_date: inception_date || "",
					expiry_date: expiry_date.toISOString().split("T")[0] || "",
					companyName: motorInsurance?.company_name || "",
					id_type: motorInsurance?.id_type,
					id_no: motorInsurance?.id_no,
					postcode: motorInsurance?.postcode || "",
					vehicle: motorInsurance?.vehicle || "",
					reg_no: motorInsurance?.reg_no || "",
					ownership_type: motorInsurance?.ownership_type || "",
					veh_type: motorInsurance?.veh_type,
					make_year: motorInsurance?.make_year || "",
					vehicle_details:
						{
							make_code: motorInsurance?.make_code,
							model_code: motorInsurance?.model_code,
							veh_capacity: motorInsurance?.capacity,
							make_year: motorInsurance?.make_year,
							engine_no: motorInsurance?.engine_no,
							chassis_no: motorInsurance?.chassis_no,
						} || {},
					variant_series:
						[
							{
								variant_name: motorInsurance?.variant_name || "",
								variant_transmission:
									motorInsurance?.variant_transmission || "",
								variant_capacity: motorInsurance?.capacity,
								variant_seat: motorInsurance?.seats,
								variant_nvic: motorInsurance?.nvic_code,
								variant_ism_market_value: motorInsurance?.sum_insured,
							},
						] || [],
				});

				let today_issue = new Date();

				let issue_date = today_issue.toISOString().split("T")[0];

				const payloads = {
					usecode: "",
					id_type: motorInsurance?.id_type,
					id_no: motorInsurance?.id_no,
					veh_reg_no: motorInsurance?.reg_no,
					postcode: motorInsurance?.postcode,
					veh_type: motorInsurance?.veh_type,
					adddriver: [],
					policy_holder_name: motorInsurance?.owner_name,
					ownership_type: motorInsurance?.ownership_type,
					gender_code: id_data?.gender || "",
					marital_code: id_data?.age >= 30 ? "M" : "S",
					dob: id_data?.dob || "",
					address1: "",
					address2: "",
					driveexp: "",
					occupation: "M36",
					cover_note_cate: "NWOO",
					issue_date: issue_date,
					inception_date: inception_date,
					expiry_date: expiry_date.toISOString().split("T")[0],
					class_code: motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
					vehicle_class_code:
						motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
					coverage_code: "CO",
					vehicle_use: "Q3",
					make_code: motorInsurance?.make_code || "",
					model_code: motorInsurance?.model_code || "",
					capacity: motorInsurance?.capacity || "",
					uom: "CC",
					make_year: motorInsurance?.make_year || "",
					seats: motorInsurance?.seats || "",
					ncd_from_code: "",
					engine_no: motorInsurance?.engine_no || "",
					chassis_no: motorInsurance?.chassis_no || "",
					nvic_code: motorInsurance?.nvic_code || "",
					sum_insured: motorInsurance?.sum_insured || "",
					email: "",
					hphoneno: "",
					msv_plan_code: "",
					extra_coverages: [],
					policy_no: policyData?.cover_note_no,
					...(selectedValueType === "market" ? { market_value: true } : {}),
					...(selectedValueType === "agree" ? { agree_value: true } : {}),
				};

				await runProgressiveQuotes(tokenParam, payloads);
			} catch (error) {
				console.error("Error fetching car quote list:", error);
			}
		} else if (tokenParam && orderId) {
			storeOrderId(orderId);
			clearCarPlanQuote(null);

			try {
				const orderDetails = await getQuoteRequest(tokenParam, {
					id: orderId,
				});
				if (
					orderDetails.success &&
					orderDetails.data &&
					orderDetails.data.quote_request
				) {
					const quotations = orderDetails.data.quotations.map((quotation) => {
						const quote = {
							image_url:
								quotation.insurance_provider === "AIA GENERAL BERHAD"
									? aiaGeneral
									: quotation.insurance_provider ===
									  "AIG MALAYSIA INSURANCE BERHAD"
									? aigMalaysia
									: quotation.insurance_provider ===
									  "ALLIANZ GENERAL INSURANCE COMPANY (MALAYSIA) BERHAD"
									? allianz
									: quotation.insurance_provider ===
									  "BERJAYA SOMPO INSURANCE BERHAD"
									? berjayaSompo
									: quotation.insurance_provider ===
									  "CHUBB INSURANCE MALAYSIA BERHAD"
									? chubb
									: quotation.insurance_provider ===
									  "ETIQA GENERAL INSURANCE BERHAD"
									? etiqaGeneral
									: quotation.insurance_provider ===
									  "ETIQA GENERAL TAKAFUL BERHAD"
									? etiqaTakaful
									: quotation.insurance_provider === "GENERALI INSURANCE BERHAD"
									? generali
									: quotation.insurance_provider ===
									  "GREAT EASTERN GENERAL INSURANCE (MALAYSIA) BERHAD"
									? greatEastern
									: quotation.insurance_provider ===
									  "LIBERTY GENERAL INSURANCE BERHAD"
									? liberty
									: quotation.insurance_provider === "LONPAC INSURANCE BERHAD"
									? lonpac
									: quotation.insurance_provider ===
									  "MSIG INSURANCE (MALAYSIA) BERHAD"
									? msig
									: quotation.insurance_provider ===
									  "PACIFIC AND ORIENT INSURANCE COMPANY BERHAD"
									? pacificOrient
									: quotation.insurance_provider ===
									  "QBE INSURANCE (MALAYSIA) BERHAD"
									? qbeMalaysia
									: quotation.insurance_provider === "RHB INSURANCE BERHAD"
									? rhb
									: quotation.insurance_provider ===
									  "SYARIKAT TAKAFUL MALAYSIA AM BERHAD"
									? takafulGeneral
									: quotation.insurance_provider ===
									  "TAKAFUL IKHLAS GENERAL BERHAD"
									? takafulIkhlas
									: quotation.insurance_provider ===
									  "THE PACIFIC INSURANCE BERHAD"
									? pacific
									: quotation.insurance_provider ===
									  "TOKIO MARINE INSURANCE (MALAYSIA) BERHAD"
									? tokioMarine
									: quotation.insurance_provider ===
									  "TUNE INSURANCE MALAYSIA BERHAD"
									? tuneProtect
									: quotation.insurance_provider ===
									  "ZURICH GENERAL INSURANCE MALAYSIA BERHAD"
									? zurichGeneral
									: quotation.insurance_provider ===
									  "ZURICH GENERAL TAKAFUL MALAYSIA BERHAD"
									? zurichTakaful
									: ansaLogo,
							insurer_name: quotation.insurance_provider,
							total_loading_percent: 0,
							total_loading_amount: 0,
							sum_insured: parseFloat(quotation.sum_insured),
							basic_premium: parseFloat(quotation.price),
							annual_premium: parseFloat(quotation.price),
							ncd_percent: parseFloat(orderDetails.data.quote_request.ncd_percent || quotation.ncd_rate),
							ncd_amount:
								(parseFloat(quotation.price) / 100) *
								parseFloat(orderDetails.data.quote_request.ncd_percent || quotation.ncd_rate),
							total_extra_coverage_amount: 0,
							gross_premium:
								parseFloat(quotation.price) -
								(parseFloat(quotation.price) / 100) *
									parseFloat(orderDetails.data.quote_request.ncd_percent || quotation.ncd_rate),
							gst_percent: 0,
							gst_premium: 0,
							sst_percent: 8,
							sst_premium: parseFloat(quotation.price) * 0.08,
							stamp_duty: 10,
							discount_percent: 0,
							discount_amount: 0,
							total_payable: (parseFloat(quotation.price) + 10) * 1.08,
							commission_percent: 10,
							commission_amount: parseFloat(quotation.price) * 0.1,
							gst_commission_percent: 0,
							gst_commission_amount: 0,
							net_premium: 0,
							act_premium: 0,
							excess_percent: 0,
							excess_amount: 0,
							msv_discount_percent: 0,
							msv_discount_amount: 0,
							entitled_mileage: 0,
							final_mileage: 0,
							veh_age_load_percent: 0,
							veh_age_loading: 0,
							ins_age_load_percent: 0,
							ins_age_loading: 0,
							claims_exp_load_percent: 0,
							claims_exp_loading: 0,
							max_cumulative_load_percent: 0,
							max_cumulative_loading: 0,
							reference_data: "",
							quotation_no: "",
							quote_ref_no: "",
							min_agreed_value: 0,
							max_agreed_value: 0,
							market_value: 0,
							extra_coverages: [],
							package_included: (quotation.plan_benefits ?? []).map(
								(benefit) => benefit.plan_benefit
							),
							add_ons: quotation.add_ons,
							product_disclosure_sheet: quotation.product_disclosure_sheet,
							policy_wording: quotation.policy_wording_document,
							tags: "All",
						};
						return quote;
					});

					const quoteRequest = orderDetails.data.quote_request;
					const firstQuotation = orderDetails.data.quotations.length > 0 ? orderDetails.data.quotations[0] : null;
					const firstQuotationNCD = firstQuotation ? firstQuotation.ncd_rate : 0;
					setNcdPercent(parseFloat(quoteRequest.ncd_percent || firstQuotationNCD ||  0));

					let id_data;
					if (
						(quoteRequest.id_type === "nric" ||
							quoteRequest.id_type === "NRIC") &&
						quoteRequest.id_no
					) {
						id_data = getDOBFromId(quoteRequest.id_no);
					}

					const payloads = {
						usecode: "",
						id_type: quoteRequest.id_type,
						id_no: quoteRequest.id_no,
						veh_reg_no: quoteRequest.veh_reg_no,
						postcode: quoteRequest.postcode,
						veh_type: quoteRequest.veh_type,
						adddriver: [],
						policy_holder_name: quoteRequest.policy_holder_name,
						ownership_type: quoteRequest.ownership_type,
						gender_code: id_data?.gender || "",
						marital_code: quoteRequest.marital_code,
						dob: id_data?.dob || "",
						address1: "",
						address2: "",
						driveexp: "",
						occupation: "M36",
						cover_note_cate: "NWOO",
						issue_date: quoteRequest.issue_date,
						inception_date: quoteRequest.inception_date,
						expiry_date: quoteRequest.expiry_date,
						class_code: quoteRequest?.class_code,
						vehicle_class_code: quoteRequest?.vehicle_class_code,
						coverage_code: "CO",
						vehicle_use: "Q3",
						make_code: quoteRequest.make_code || "",
						model_code: quoteRequest.model_code || "",
						capacity: quoteRequest.capacity || "",
						uom: "CC",
						make_year: quoteRequest.make_year || "",
						seats: quoteRequest.seats.toString() || "",
						ncd_from_code: "",
						engine_no: quoteRequest.engine_no || "",
						chassis_no: quoteRequest.chassis_no || "",
						nvic_code: quoteRequest.nvic_code || "",
						sum_insured: quoteRequest.sum_insured || "",
						email: "",
						hphoneno: "",
						msv_plan_code: "",
						extra_coverages: [],
						...(selectedValueType === "market" ? { market_value: true } : {}),
						...(selectedValueType === "agree" ? { agree_value: true } : {}),
						isRecon: isRecon,
					};

					setIsMoreQuoatation(false);

					setVehicleInfo({
						owner_name: quoteRequest?.policy_holder_name || "",
						insurer_name: plan?.insurer_name || "",
						companyName: quoteRequest?.company_name || "",
						id_type: quoteRequest?.id_type,
						id_no: quoteRequest?.id_no,
						postcode: quoteRequest?.postcode || "",
						effective_date: quoteRequest.inception_date || "",
						expiry_date: quoteRequest.expiry_date || "",
						vehicle:
							`${quoteRequest?.capacity} ${quoteRequest?.uom} - ${quoteRequest?.make_year}` ||
							"",
						reg_no: quoteRequest?.veh_reg_no || "",
						ownership_type: quoteRequest?.ownership_type || "",
						veh_type: quoteRequest?.veh_type,
						make_year: quoteRequest?.make_year || "",
						vehicle_details:
							{
								make_code: quoteRequest?.make_code,
								model_code: quoteRequest?.model_code,
								veh_capacity: quoteRequest?.capacity,
								make_year: quoteRequest?.make_year,
								engine_no: quoteRequest?.engine_no,
								chassis_no: quoteRequest?.chassis_no,
							} || {},
						variant_series:
							[
								{
									variant_name: quoteRequest?.variant_name || "",
									variant_transmission:
										quoteRequest?.variant_transmission || "",
									variant_capacity: quoteRequest?.capacity,
									variant_seat: quoteRequest?.seats,
									variant_nvic: quoteRequest?.nvic_code,
									variant_ism_market_value: quoteRequest?.sum_insured,
								},
							] || [],
					});

					const selectedVariant = {
						variant_seat: quoteRequest?.seats || "",
						variant_nvic: quoteRequest?.nvic_code || "",
						variant_ism_market_value: quoteRequest?.sum_insured || "",
						variant_name: quoteRequest?.variant_name || "",
						variant_transmission: quoteRequest?.variant_transmission || "",
						variant_capacity: quoteRequest?.variant_capacity || "",
					};

					localStorage.setItem(
						"selectedVariant",
						JSON.stringify(selectedVariant)
					);

					// Call the quotes API progressively; merge each cumulative batch with the
					// order's existing manual quotations as cards arrive (was a single blocking
					// getQuotes — this is the primary new-quote plan-page load path).
					await runProgressiveQuotes(tokenParam, payloads, {
						onResults: (cards, { complete }) => {
							// List of insurer names already in quotations
							const existingInsurers = quotations.map(q => q.insurer_name);
							// Filter cards to exclude any insurer already mapped to one in quotations
							const filteredGetQuoteData = (Array.isArray(cards) ? cards : []).filter(item => {
								const mapped = manualInsurersMapping.find(
									m => m.insurer_name === item.insurer_name
								);
								const mappedFullName = mapped ? mapped.insurer_fullname : item.insurer_name;

								// Include only if the mapped full name does NOT exist in quotations
								return !existingInsurers.includes(mappedFullName);
							});
							// Combine filtered cards with quotations
							const combinedPlans = [...filteredGetQuoteData.map(quote => {
								if (!quote.sum_insured) {
									return {
										insurer_name: quote.insurer_name,
										image_url: quote.image_url,
										package_included: quote.package_included,
										error_message: quote.error_message,
									}
								}
								return quote;
							}), ...quotations];

							setPlans(combinedPlans);

							if (Array.isArray(combinedPlans) && combinedPlans.length > 0) {
								const prices = combinedPlans
												.map((item) => parseFloat(item.gross_premium))
												.filter((price) => !isNaN(price));
								if (prices.length > 0) {
									const minPrice = Math.min(...prices);
									const maxPrice = Math.max(...prices);

									setTempPriceRange([minPrice, maxPrice]);
									setPriceRange([minPrice, maxPrice]);
								}
							}

							if (complete) {
								localStorage.setItem(
									"additional_quotes",
									JSON.stringify(orderDetails.data.quotations)
								);
								setCarQuoteList(cards); // Update car plan list
							}
						}
					});
				}
			} catch (error) {
				console.error("Error fetching more quote list:", error);
			}
		} else {
			// Fresh new-quote flow: the variant page started a progressive session and handed
			// the id over. Poll it and render insurer cards as each one prices (instead of the
			// old behaviour where the variant page blocked on the full batch and cached it).
			const handoffSessionId =
				typeof localStorage !== "undefined"
					? localStorage.getItem("quote_session_id")
					: null;
			if (handoffSessionId) {
				const storedPayload = (() => {
					try {
						return JSON.parse(localStorage.getItem("quote_session_payload") || "null");
					} catch (e) {
						return null;
					}
				})();
				setLoading(false); // let runProgressiveQuotes' loadPlans drive the spinner
				await runProgressiveQuotes(token, storedPayload || {}, {
					sessionId: handoffSessionId,
					onFlag: (flag) => {
						const msg =
							flag === "is_wrong_owner"
								? "Sorry, your car plate number does not match the given NRIC. Please try again with the correct details."
								: "You cannot renew as early as 60 days before your expiry date.";
						showErrorMessage(msg);
						navigate("/get-quote/select-car-variant");
					},
				});
				return;
			}
			if (Array.isArray(getCarQuoteList) && getCarQuoteList.length > 0) {
				const prices = getCarQuoteList
								.map((item) => parseFloat(item.gross_premium))
								.filter((price) => !isNaN(price));
				console.log(prices);
				const minPrice = Math.min(...prices);
				const maxPrice = Math.max(...prices);

				setPlans(getCarQuoteList);
				setTempPriceRange([minPrice, maxPrice]);
				setPriceRange([minPrice, maxPrice]);
			} else {
				setPlans([]);
				setTempPriceRange([0, 0]);
				setPriceRange([0, 0]);
			}
		}

		setAddOnSelection([]);
		setLoading(false);
	};

	const plansPerPage = 99;

	const paginatePlans = () => {
		try {
			if (Array.isArray(plans) && plans.length > 0) {
				const startIndex = (currentPage - 1) * plansPerPage;
				const endIndex = startIndex + plansPerPage;

				let filteredPlans = plans.filter((plan) => {
					const entries = Object.entries(plan);
					if (entries.length === 0) return false;

					const displayName = plan.insurer_name;
					// console.log(plan.insurer_name);
					const matchesProvider =
						filter.selectedProviders.length === 0 ||
						filter.selectedProviders.includes(getInsurerName(displayName));

					const discountedPrice = parseFloat(plan.gross_premium);
					const hasPrice = !isNaN(discountedPrice);

					// Only include plans within price range *if they have a valid price*.
					// Otherwise, include them only if your filter allows missing prices.
					const matchesPrice = hasPrice
						? discountedPrice >= filter.priceRange[0] &&
								discountedPrice <= filter.priceRange[1]
							: plan.insurer_name === "LONPAC"
							? false
							: true;

					let matchesValueType = true;
					if (filter.valueType === "agree") {
						matchesValueType = plan.agree_value === true;
					} else if (filter.valueType === "market") {
						matchesValueType = plan.market_value === true;
					}

					return (
						matchesProvider && matchesPrice && matchesValueType
					);
				});

				if (sortByPrice === "lowestToHighest") {
					filteredPlans = filteredPlans.sort((a, b) => {
						const aPrice = parseFloat(a.gross_premium) || 0;
						const bPrice = parseFloat(b.gross_premium) || 0;
				
						// Push plans with no price (0 or missing) to the bottom
						if (!a.gross_premium && b.gross_premium) return 1;
						if (a.gross_premium && !b.gross_premium) return -1;
				
						return aPrice - bPrice;
					});
				} else if (sortByPrice === "highestToLowest") {
					filteredPlans = filteredPlans.sort((a, b) => {
						const aPrice = parseFloat(a.gross_premium) || 0;
						const bPrice = parseFloat(b.gross_premium) || 0;
				
						// Push plans with no price to the bottom
						if (!a.gross_premium && b.gross_premium) return 1;
						if (a.gross_premium && !b.gross_premium) return -1;
				
						return bPrice - aPrice;
					});
				}				

				return filteredPlans.slice(startIndex, endIndex);
			}
			return [];
		} catch (error) {
			showErrorMessage("An error occurred while processing plans.");
			return [];
		}
	};

	const renderPlans = () => {
		if (plans && plans.length > 0) {
			const validPlans = plans;
			console.log(validPlans);
			if (validPlans.length === 0) {
				return <p>{t(`healthInsurance.selectHealthPlan.noQuoteAvailable`)}</p>;
			}

			return paginatePlans().map((pagplan, index) => {
				return (
					<div
						key={`${pagplan.insurer_name}-${pagplan.annual_premium}`}
						className="car-plan-card border-radius-25 p-0 m-0"
					>
						{pagplan.isRecommended && (
							<div className="recommended-badge fw-medium">
								{t("common.recommended")}
							</div>
						)}
						<div className="w-100 p-40">
							<div className="d-flex flex-row input-group justify-content-center align-items-center gap-4 mb-0">
								{pagplan.gross_premium && !isNaN(parseFloat(pagplan.gross_premium)) && (
									<RadioButton
										inputId={`insurance-${index}`}
										name="insurance"
										value={pagplan.insurer_name}
										onChange={() => setPlan(pagplan)}
										checked={pagplan.insurer_name === plan.insurer_name}
									/>
								)}
								<div className="w-80 mb-2">
									{pagplan.image_url ? (
										<Image
											width="100%"
											height="auto"
											src={pagplan.image_url}
											alt={pagplan.insurer_name}
											style={{
												maxWidth: [
													"GENERALI",
													"BERJAYA SOMPO",
													"TAKAFUL IKHLAS",
													"TUNE PROTECT",
												].includes(pagplan.insurer_name)
													? "110px"
													: "150px",
												height: "auto",
												display: "block",
												margin: "0",
											}}
										/>
									) : (
										<div>{pagplan.insurer_name}</div>
									)}
								</div>
							</div>
							{pagplan.insurer_name === "LIBERTY" && (
								<div className="pb-3">
									<span style={{ fontSize: "12px", lineHeight: "14px" }}>
										{`Advance Fin Advisory is the registered Financial Advisor for Liberty General Insurance Berhad 197801007153 (44191-P)`}
									</span>
								</div>
							)}
							{/* TIMB NDDP item 1 (Ansa-Support#30) — same wording as before, now from the
								shared component so the package page and the payment summary print exactly
								what TIMB accepted here. Still gated to Tune: the other insurers have their
								own approved disclosure wording (Liberty's is the block above). */}
							{pagplan.insurer_name === "TUNE PROTECT" && (
								<UnderwriterDisclosure insurerName={pagplan.insurer_name} />
							)}
							{parseFloat(pagplan.sum_insured) > 0 &&
								<>
								<div className="pb-3">
									<span className="fw-bold">
										{`Sum Covered/Sum Insured ${
											pagplan?.insurer_name === "LONPAC"
												? "(Agreed Value)"
												: pagplan?.agree_value
												? "(Agreed Value)"
												: pagplan?.market_value
												? "(Market Value)"
												: "(Agreed Value)"
										}:`}
									</span>
									<br />
									<span>
										{`RM ${
											new Intl.NumberFormat("en-US", {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											}).format(pagplan.sum_insured || 0) || ""
										}`}
									</span>
								</div>
								</>
							}
							<span className="color-heading fw-bold">
								{t(`autoInsurance.selectCarPlan.whatsIncludedInYourPackage`)}
							</span>
							<div className="py-2">
								{pagplan.package_included &&
									pagplan.package_included.map((benefit, i) => (
										<div className="p-2" key={i}>
											<FaCheck />
											{"  "}
											<span
												dangerouslySetInnerHTML={{
													__html: benefit.replace(/\n/g, "<br />"),
												}}
											/>
										</div>
									))}
							</div>
							{!pagplan.gross_premium &&
								<>
								<div className="d-flex flex-row align-items-start justify-content-even p-2 mb-2 border-radius-14 bg-gray-100">
									<img
										src={infoIcon}
										alt="success-resp"
										loading="lazy"
										style={{
											objectFit: "contain",
											width: "22px",
											height: "auto"
										}}
									/>
									<p 
										className="formatted-text text-left m-0"
										style={{
											width: "85%"
										}}
									>
										Your vehicle is not supported by this insurer.
									</p>
								</div>
								</>
							}
							{parseFloat(pagplan.sum_insured) > 0 ? 
								parseFloat(pagplan?.basic_premium) >
								parseFloat(pagplan?.gross_premium) ? (
									<>
									<div className="d-block justify-content-between">
										<span 
											className="fs-xl fw-bold"
										>
											{`RM ${
												new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(pagplan?.gross_premium || 0) || ""
											}`}
										</span>
										<span> {t(`autoInsurance.selectCarPlan.afterDiscount`)}</span>
										<p className="original-price m-0">
											<s className="formatted-text">
												{`RM ${
													new Intl.NumberFormat("en-US", {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}).format(pagplan?.basic_premium || 0) || ""
												}`}
											</s>
										</p>
									</div>
									</>
								) : (
									<>
										<span className="fs-xl fw-bold">
											{`RM ${
												new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(pagplan?.gross_premium || 0) || ""
											}`}
										</span>
									</>
								)
								:
								<></>
							}
						</div>
					</div>
				);
			});
		}

		return [];
	};

	const handleSliderChange = (event, newValue) => {
		setSelectedSumInsured(newValue);
	};	

	const submitSelectedPlan = (e) => {
		e.preventDefault();

		try {
			if (!plan || !plan.insurer_name) {
				throw new Error("No plan selected. Please select a plan to proceed.");
			}

			setVehicleInfo({
				...vehicleInfo,
				suminsured: plan?.sum_insured,
				insurer_name: plan?.insurer_name,
			});

			storeCarPlan(plan);

			if (plan && plan.road_tax_option) {
				localStorage.setItem("road_tax_option_api", plan.road_tax_option);
			}

			navigate(
				policyId
					? `/get-quote/add-ons?policy_id=${policyId}`
					: `/get-quote/add-ons`,
				{
					state: {
						fetchCarAddon:
							new URLSearchParams(window.location.search).get("order_id") ===
							null,
					},
				}
			);
		} catch (error) {
			showErrorMessage("Failed to submit the selected plan.");
		}
	};

	const showPopUp = async (e) => {
		e.preventDefault();

		if (plan) {
			setPlan("");
		}

		setIsReqMoreQuoteVisible(true);
	};

	const submitMoreQuotes = async (e) => {
		e.preventDefault();

		setIsSuccessModalVisible(false);
		setLoader2(true);

		let id_data;
		if (
			(vehicleInfo.id_type === "nric" || vehicleInfo.id_type === "NRIC") &&
			vehicleInfo.id_no
		) {
			id_data = getDOBFromId(vehicleInfo.id_no);
		}

		let today = new Date();

		let issue_date = today.toISOString().split("T")[0];

		try {
			const payloads = {
				usecode: "",
				id_type: vehicleInfo.id_type,
				id_no: vehicleInfo.id_no,
				veh_reg_no: vehicleInfo.reg_no,
				postcode: vehicleInfo.postcode,
				veh_type: vehicleInfo.veh_type,
				//adddriver: [],
				policy_holder_name:
					vehicleInfo.ownership_type === "I"
						? vehicleInfo.owner_name
						: vehicleInfo.companyName,
				ownership_type: vehicleInfo.ownership_type,
				gender_code: id_data?.gender || "",
				marital_code: vehicleInfo.marital_status,
				dob: id_data?.dob || "",
				address1: "",
				address2: "",
				driveexp: "",
				occupation: "M36",
				cover_note_cate: "NWOO",
				issue_date: issue_date,
				inception_date: vehicleInfo.effective_date,
				expiry_date: vehicleInfo.expiry_date,
				class_code: vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				vehicle_class_code:
					vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
				coverage_code: "CO",
				vehicle_use: "Q3",
				make_code: vehicleInfo?.vehicle_details?.make_code || "",
				model_code: vehicleInfo?.vehicle_details?.model_code || "",
				capacity: vehicleInfo?.vehicle_details?.veh_capacity || "",
				uom: "CC",
				make_year: vehicleInfo?.vehicle_details?.make_year || 0,
				seats: selectedVariant?.variant_seat || 0,
				ncd_from_code: "",
				engine_no: vehicleInfo?.vehicle_details?.engine_no || "",
				chassis_no: vehicleInfo?.vehicle_details?.chassis_no || "",
				nvic_code: selectedVariant?.variant_nvic || "",
				sum_insured: 0,
				email: "",
				hphoneno: "",
				company_name: vehicleInfo.companyName || "",
				variant_name: selectedVariant.variant_name || "",
				variant_transmission: selectedVariant.variant_transmission || "",
				variant_capacity: selectedVariant.variant_capacity || "",
				// msv_plan_code: "",
				// extra_coverages: [],
				market_value: true,
				vehicle_model: vehicleInfo?.vehicle,
				ncd_percent: vehicleInfo?.ncd_percent || 0,
				preferred_insurers: selectedInsurers || []
			};

			const getMoreQuotesDetails = await getMoreQuotes(token, payloads);
			if (getMoreQuotesDetails.success) {
				if (getMoreQuotesDetails.data && getMoreQuotesDetails.data.orderId) {
					const order = await getOrder(token, {
						id: getMoreQuotesDetails.data.orderId,
					});
					if (order.success && order.data && order.data.order_number) {
						setLoader2(false);

						setImage(submitSuccessFul);
						setDialogTitle("Request Submitted");
						setRespMessage(
							"You have successfully requested a new quotation.\n You'll be notified through the ANSA App and email once your quotations are ready."
						);
						setIsReqMoreQuoteVisible(false);
						setDialogOpen(true);
						clearCacheAndState();
						//navigate(
						//	`/payment/response?status=1&refNo=${order.data.order_number}&amount=0&roadtaxrenewal=0`
						//);
					} else {
						setLoader2(false);

						setImage(submitFail);
						setDialogTitle("Failed to Request");
						setRespMessage(
							"Failed to request a new quotation, please try again later"
						);
						setIsReqMoreQuoteVisible(false);
						setDialogOpen(true);
						clearCacheAndState();
					}
				}
			} else {
				setLoader2(false);

				setImage(submitFail);
				setDialogTitle("Failed to Request");
				setRespMessage(
					"Failed to request a new quotation, please try again later"
				);
				setIsReqMoreQuoteVisible(false);
				setDialogOpen(true);
			}
		} catch (error) {
			showErrorMessage(error.message, "Something went wrong");
			setLoader2(false);
		}
	};

	const openFilterModal = () => {
		setTempSelectedValueType(selectedValueType);
		setIsModalVisible(true);
	};

	const closeFilterModal = () => {
		setIsModalVisible(false);
	};

	const closeReqQuoteModal = () => {
		setIsReqMoreQuoteVisible(false);
	}

	const handleSelectedInsurer = (insurerName) => {
		let updatedInsurers;

		if (selectedInsurers.includes(insurerName)) {
			// If already selected -> remove it
			updatedInsurers = selectedInsurers.filter((name) => name !== insurerName);
		} else {
			// Add only if under the 3 limit
			if (selectedInsurers.length < 3) {
				updatedInsurers = [...selectedInsurers, insurerName];
			} else {
				// Optional: Prevent more than 3
				return;
			}
		}

		// Update state with new selection
		setSelectedInsurers(updatedInsurers);

		// Then update quote count (based on new list)
		setQuoteSelected(updatedInsurers.length);
	};  

	const getInsurerMessage = (count) => {
		if (count === 0) return "Select your preferred insurers";
		if (count === 1) return "You've selected 1 insurer";
		if (count === 2) return "You've selected 2 insurers";
		return "You've reached the maximum of 3 insurers.";
	};

	const moreQuotesOptions = [
		{ insurer_name: "MSIG", insurer_logo: msig, width: "80px", height: "auto" },
		{ insurer_name: "Zurich", insurer_logo: zurichGeneral, width: "80px", height: "auto" },
		{ insurer_name: "Zurich Takaful", insurer_logo: zurichTakaful, width: "100px", height: "auto" },
		{ insurer_name: "Great Eastern", insurer_logo: greatEastern, width: "80px", height: "auto" },
		{ insurer_name: "Takaful Malaysia", insurer_logo: takafulGeneral, width: "100px", height: "auto" },
		{ insurer_name: "Liberty", insurer_logo: liberty, width: "90px", height: "auto" },
		{ insurer_name: "Generali", insurer_logo: generali, width: "60px", height: "auto" },
		{ insurer_name: "RHBI", insurer_logo: rhb, width: "100px", height: "auto" },
		{ insurer_name: "Berjaya Sompo", insurer_logo: berjayaSompo, width: "80px", height: "auto" },
		{ insurer_name: "Tokio Marine", insurer_logo: tokioMarine, width: "80px", height: "auto" },
		{ insurer_name: "TUNE", insurer_logo: tuneProtect, width: "60px", height: "auto" },
		{ insurer_name: "Lonpac", insurer_logo: lonpac, width: "100px", height: "auto" },
		{ insurer_name: "Takaful Ikhlas", insurer_logo: takafulIkhlas, width: "60px", height: "auto" },
		{ insurer_name: "Allianz", insurer_logo: allianz, width: "90px", height: "auto" },
		{ insurer_name: "Etiqa", insurer_logo: etiqaGeneral, width: "70px", height: "auto" },
	];

	const handleApplyFilter = () => {
		const oldFilter = {
			...filter,
		};

		const currentFilter = {
			...filter,
			priceRange: priceRange,
			selectedProviders: selectedProviders,
			valueType: selectedValueType,
			sumInsured: enableSumInsuredFilter ? selectedSumInsured : null,
			enableSumInsuredFilter: enableSumInsuredFilter
		};

		console.log("New Filter", currentFilter);
		console.log("Current Filter", filter);

		setFilter(currentFilter);

		if (currentFilter.valueType !== oldFilter.valueType || 
				(currentFilter.enableSumInsuredFilter !== oldFilter.enableSumInsuredFilter) ||
				(currentFilter.enableSumInsuredFilter && 
					currentFilter.sumInsured !== oldFilter.sumInsured)
			) {
			handleValueTypeChange(currentFilter.valueType, currentFilter.enableSumInsuredFilter ? selectedSumInsured : null);
		}

		setTagsVisible(true);
		closeFilterModal();
	};

	function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);

		if (isNaN(date)) return ""; // handle invalid date

		const day = String(date.getDate()).padStart(2, "0");

		const months = [
			"JAN",
			"FEB",
			"MAR",
			"APR",
			"MAY",
			"JUN",
			"JUL",
			"AUG",
			"SEP",
			"OCT",
			"NOV",
			"DEC",
		];

		const month = months[date.getMonth()];
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	}

	const getActiveFiltersCount = () => {
		let count = 0;

		// Check for price range filter
		if (tempPriceRange[0] !== 1 || tempPriceRange[1] !== 99999) count++;

		// Check for insurance provider filter
		if (selectedProviders.length > 0) count++;

		// Check for value type filter (include "agree" and other types)
		if (selectedValueType) count++;

		return count;
	};

	const toggleProvider = (displayName) => {
		setSelectedProviders((prevSelected) => {
			if (prevSelected.includes(displayName)) {
				return prevSelected.filter((p) => p !== displayName);
			} else {
				return [...prevSelected, displayName];
			}
		});
	};

	const clearCacheAndState = () => {
		// Clear Redux store
		clearVehicleInfo(null);
		clearCarAddOn(null);
		clearCarAddOnSelection(null);
		clearCarQuoteList(null);
		clearCarPlanQuote(null);

		// Clear localStorage
		const cacheKeys = ["cachedAddress", "drivers"];
		cacheKeys.forEach((key) => localStorage.removeItem(key));
	};

	const validPlans = plans?.filter(
		(p) =>
		  p.gross_premium &&
		  !isNaN(parseFloat(p.gross_premium)) &&
		  parseFloat(p.gross_premium) > 0
	) || [];

	return (
		<>
			<div className="select-car-plan-page">
				<div className="content">
					<div className="get-quote-process-container">
						<div className="d-flex w-100">
							<div
								className="select-variant-container mb-2 p-0"
								style={{ maxHeight: "100vh", overflow: "auto" }}
							>
								<div className="owner-info">
									<div className="card">
										<h4 className="owner-info-title mt-2">
											{t(`autoInsurance.selectCarPlan.titleCard`)}
										</h4>
										<div className="owner-info-row p-0">
											<span style={{ lineHeight: "10px" }}>
												{t(`common.vehicleRegistrationNo`)}
											</span>
											<strong style={{ lineHeight: "10px" }}>
												{vehicleInfo?.reg_no}
											</strong>
										</div>
										<div className="owner-info-row p-0">
											<span style={{ lineHeight: "10px" }}>
												{t(`common.qualifiedNCD`)}
											</span>
											<strong style={{ lineHeight: "10px" }}>{`${parseFloat(
												vehicleInfo?.ncd_percent || ncdPercent
											)}%`}</strong>
										</div>
										<div className="owner-info-row p-0">
											<span style={{ lineHeight: "10px" }}>
												{t(`autoInsurance.carDetails.coveragePeriod`)}
											</span>
											<strong>
												{formatDate(vehicleInfo?.effective_date)}
												<br />
												- {formatDate(vehicleInfo?.expiry_date)}
											</strong>
										</div>
									</div>
								</div>
							</div>
							<div className="d-flex flex-column">
								<h3 className="mt-2 mb-0">
									{t(`autoInsurance.selectCarPlan.title`)}
								</h3>
								<p className="formatted-text">
									{t(`autoInsurance.selectCarPlan.subTitle`)}
								</p>
							</div>

							<div
								className="filter d-flex flex-row align-items-center bg-light-blue p-10 mb-2"
								onClick={openFilterModal}
							>
								<i className="pi pi-filter-fill pr-10"></i>{" "}
								<span className="pr-20">{t(`common.filterBy`)}</span>
								{getActiveFiltersCount() > 0 && (
									<span className="filter-badge">
										{getActiveFiltersCount()}
									</span>
								)}
								<i className="pi pi-angle-down"></i>
							</div>

							<Dialog
								className="filter-modal d-flex flex-row bg-white p-40 gap-2"
								modal
								header={t(`common.filters`)}
								visible={isModalVisible}
								style={{
									borderRadius: "24px 24px 0 0",
									margin: 0,
									width: "100vw",
									overflowY: "auto",
								}}
								position={"bottom"}
								onHide={closeFilterModal}
								content={({ hide }) => (
									<>
										<div className="filters w-100">
											<div className="d-flex justify-content-between mb-4">
												<div className="w-80">
													<h2 className="m-0">{`Filters`}</h2>
													<span className="formatted-text">
														{t(
															`healthInsurance.selectHealthPlan.filters.subTitle`
														)}
													</span>
												</div>
												<div className="w-20" onClick={closeFilterModal}>
													<i className="pi pi-times-circle color-primary"></i>
													{` `}
													<span className="color-primary">
														{t(`common.close`)}
													</span>
												</div>
											</div>
											{/* Filter Content */}
											<div className="filters">
												{/* Insurance Provider Filter */}
												<div className="mb-4">
													<h4>
														{t(
															`healthInsurance.selectHealthPlan.filters.insuranceProvider`
														)}
													</h4>
													<div className="providers d-flex flex-wrap gap-2">
														{Array.from(
															new Set(
																plans.map((plan) => {
																	return getInsurerName(plan.insurer_name);
																})
															)
														).map((displayName, index) => (
															<div
																key={index}
																className={`provider-btn ${
																	selectedProviders.includes(displayName)
																		? "active"
																		: ""
																}`}
																onClick={() => toggleProvider(displayName)}
															>
																{displayName}
															</div>
														))}
													</div>
												</div>

												{/* Price Range Filter */}
												<div className="mb-4">
													<h4 className="mb-2">
														Sum Insured
													</h4>
													<div className="slider-labels d-flex justify-content-between">
														<span className="price-label">
															{`RM ${Math.min(agreeValueRange[0], marketValueRange[0])}`}
														</span>
														<span className="price-label">
															{`RM ${Math.max(agreeValueRange[1], marketValueRange[1])}`}
														</span>
													</div>
													<div className="slider-container">
														<Slider
															disabled={!enableSumInsuredFilter}
															value={selectedSumInsured}
															onChange={handleSliderChange}
															min={Math.min(agreeValueRange[0], marketValueRange[0])}
															max={Math.max(agreeValueRange[1], marketValueRange[1])}
															step={1000}
															sx={{
																color: "#0B4FE4",
																height: 8,
																"& .MuiSlider-thumb": {
																	height: 24,
																	width: 24,
																	border: "2px solid",
																},
																"& .MuiSlider-rail": {
																	opacity: 0.3,
																	height: 8,
																},
															}}
														/>
													</div>
													<div className="price-range-display mt-2">
														<span>{`RM ${selectedSumInsured}`}</span>
													</div>
													<div className="flex align-items-center">
														<Checkbox
															id="enable_sum_insured"
															name="enable_sum_insured"
															checked={enableSumInsuredFilter}
															onChange={(e) => setEnableSumInsuredFilter(e.target.checked) }
															inputProps={{ "aria-label": "controlled" }}
														/>
														<label htmlFor="enable_sum_insured" className="mb-0">
															Enable Sum Insured Filter
														</label>
													</div>
												</div>

												{/* Other filters like Agree Value, Market Value */}
												<div className="mb-4">
													<h4>
														{t(`autoInsurance.selectCarPlan.filters.valueType`)}
													</h4>
													<div className="d-flex gap-2 align-items-center">
														<label className="mb-0">
															<input
																type="radio"
																name="valueType"
																value="market"
																checked={selectedValueType === "market"}
																onChange={(e) => {
																	setSelectedValueType(e.target.value);
																}}
															/>
															{t(
																`autoInsurance.selectCarPlan.filters.marketValue`
															)}
														</label>
														<label className="mb-0">
															<input
																type="radio"
																name="valueType"
																value="agree"
																checked={selectedValueType === "agree"}
																onChange={(e) => {
																	setSelectedValueType(e.target.value);
																}}
															/>
															{t(
																`autoInsurance.selectCarPlan.filters.agreeValue`
															)}
														</label>
														{/* clear button */}
														{selectedValueType && (
															<div
																className="d-flex align-items-center gap-1 underline"
																onClick={() => {
																	setSelectedValueType("");
																}}
															>
																<span className="color-primary">clear</span>
															</div>
														)}
													</div>
												</div>

												<div className="mb-4">
													<h4>Sort By Price</h4>
													<div className="d-flex gap-2">
														<label>
															<input
																type="radio"
																name="sortByPrice"
																value="lowestToHighest"
																checked={sortByPrice === "lowestToHighest"}
																onChange={(e) => {
																	setSortByPrice(e.target.value);
																	setPlans(
																		plans.sort((a, b) => {
																			if (a.gross_premium < b.gross_premium) {
																				return -1;
																			}
																			if (a.gross_premium > b.gross_premium) {
																				return 1;
																			}
																			return 0;
																		})
																	);
																}}
															/>
															Lowest to Highest
														</label>
														<label>
															<input
																type="radio"
																name="sortByPrice"
																value="highestToLowest"
																checked={sortByPrice === "highestToLowest"}
																onChange={(e) => {
																	setSortByPrice(e.target.value);
																	setPlans(
																		plans.sort((a, b) => {
																			if (a.gross_premium > b.gross_premium) {
																				return -1;
																			}
																			if (a.gross_premium < b.gross_premium) {
																				return 1;
																			}
																			return 0;
																		})
																	);
																}}
															/>
															Highest to Lowest
														</label>
													</div>
												</div>
											</div>
										</div>
										<Button
											className="btn-primary"
											disabled={loadPlans}
											label={t(`common.applyFilter`)}
											onClick={handleApplyFilter}
										/>
									</>
								)}
							></Dialog>

							<div className="tag-group d-flex flex-row gap-2 mb-2">
								{tagsVisible && (
									<>
										{Array.isArray(filter.priceRange) &&
											filter.priceRange.length === 2 &&
											(filter.priceRange[0] !== tempPriceRange[0] ||
												filter.priceRange[1] !== tempPriceRange[1]) && (
												<div className="tags bg-primary p-10 border-radius-5">
													<span>{`${t(
														`autoInsurance.selectCarPlan.filters.yearlyPriceRange`
													)} - RM${filter.priceRange[0]} - RM${filter.priceRange[1]}`}</span>
													<i
														className="pi pi-times color-light ml-2 cursor-pointer"
														onClick={() => {
															setPriceRange(tempPriceRange);
															setFilter({
																...filter,
																priceRange: priceRange,
															});
														}}
													></i>
												</div>
											)}

										{filter.selectedProviders.length > 0 && (
											<div className="tags bg-primary p-10 border-radius-5">
												<span>{`${t(`common.insurance`)} - ${
													filter.selectedProviders
												}`}</span>
												<i
													className="pi pi-times color-light ml-2 cursor-pointer"
													onClick={() => {
														setSelectedProviders([]);
														setFilter({
															...filter,
															selectedProviders: [],
														});
													}}
												></i>
											</div>
										)}

										{filter.valueType && filter.valueType !== "market" && (
											<div className="tags bg-primary p-10 border-radius-5">
												<span>{`${t(
													`autoInsurance.selectCarPlan.filters.value`
												)} - ${filter.valueType
													.charAt(0)
													.toUpperCase()}${filter.valueType.slice(1)}`}</span>
												<i
													className="pi pi-times color-light ml-2 cursor-pointer"
													onClick={() => {
														setSelectedValueType(""); // Reset to default
														handleValueTypeChange("");
														setFilter({
															...filter,
															valueType: "",
														});
													}}
												></i>
											</div>
										)}
									</>
								)}
							</div>

							{!hasAppSession ? (
								<AppOnlyNotice
									title={t(`auto.appOnlyTitle`)}
									body={t(`auto.appOnlyBody`)}
									enquiryText={t(`auto.appOnlyEnquiry`)}
									enquiryLinkText={t(`auto.appOnlyEnquiryLink`)}
									enquiryService="Motor Insurance"
								/>
							) : sessionExpired ? (
								<div className="plan-grid d-flex justify-content-center gap-4">
									<h4>{t(`autoInsurance.selectCarPlan.sessionExpiredTitle`)}</h4>
									<p>{t(`autoInsurance.selectCarPlan.sessionExpiredBody`)}</p>
								</div>
							) : (loading || loadPlans) && (!plans || plans.length === 0) ? (
								<div className="plan-grid d-flex justify-content-center gap-4">
									<p>{t(`autoInsurance.selectCarPlan.loadingPlans`)}</p>
								</div>
							) : plans && plans.length > 0 ? (
								<div
									className="plan-grid d-flex justify-content-center gap-4"
									style={{
										marginBottom: offsetHeight / 2.5,
									}}
								>
									{renderPlans()}
									{loadingMore && (
										<div className="plan-grid d-flex justify-content-center gap-4">
											<p>{t(`autoInsurance.selectCarPlan.loadingPlans`)}</p>
										</div>
									)}
									{isMoreQuoatation && (
										<>
											{moreQuoteEnabled && validPlans.length < 2 && (
											<div
												className="btn-link-primary-no-fill mt-0"
												onClick={(e) => showPopUp(e)}
											>
												{t(`autoInsurance.selectCarPlan.requestMoreQuotation`)}
											</div>
											)}

											<span
												style={{ fontSize: "12px", lineHeight: "14px" }}
											>
												{`All insurance products are underwritten by corresponding insurers listed on this platform and distributed by Advance Fin Advisory Sdn Bhd, an Approved Financial Advisor under Bank Negara Malaysia. For any claims assistance, complaints or product information, please contact us at `}
												<a href="tel:+60327795998" className="color-primary">
													{`+603-2779 5998`}
												</a>
												.
											</span>
										</>
									)}
								</div>
							) : (
								<div className="plan-grid d-flex justify-content-center gap-4">
									<p>
										{t(`healthInsurance.selectHealthPlan.noQuoteAvailable`)}
									</p>
									{moreQuoteEnabled && (
									<div
										className="btn-link-primary-no-fill mt-0"
										onClick={(e) => showPopUp(e)}
									>
										{t(`autoInsurance.selectCarPlan.requestMoreQuotation`)}
									</div>
									)}
									<span style={{ fontSize: "12px", lineHeight: "14px" }}>
										{`All insurance products are underwritten by corresponding insurers listed on this platform and distributed by Advance Fin Advisory Sdn Bhd, an Approved Financial Advisor under Bank Negara Malaysia. For any claims assistance, complaints or product information, please contact us at `}
										<a href="tel:+60327795998" className="color-primary">
											{`+603-2779 5998`}
										</a>
										.
									</span>
								</div>
							)}
							
							<Dialog
								className="filter-modal d-flex flex-row bg-white p-5 gap-2"
								modal
								header={`Select Your Preferred Insurers`}
								visible={isReqMoreQuoteVisible}
								style={{
									borderRadius: "24px 24px 0 0",
									margin: 0,
									width: "100vw",
									overflowY: "auto",
								}}
								position={"bottom"}
								onHide={closeReqQuoteModal}
								content={({ hide }) => (
									<>
										<div className="filters w-100">
											<div className="d-flex justify-content-between mb-4">
												<div className="w-80 mb-2">
													<h3 className="m-0">{`Select Your Preferred Insurers`}</h3>
												</div>
												<div className="w-20" onClick={closeReqQuoteModal}>
													<i className="pi pi-times-circle color-primary"></i>
													{` `}
													<span className="color-primary">
														{t(`common.close`)}
													</span>
												</div>
												<span className="formatted-text">Choose up to 3 insurers from the list below for your manual quotation request.</span>
											</div>
											<div className="filters">
												<div className="mb-4">
													<span className="color-primary fw-bold">
														{getInsurerMessage(quoteSelected)}
													</span>
												</div>

												<div className="insurer-grid grid-cols-2 gap-3">
													{moreQuotesOptions.map((option, index) => {
														const isSelected = selectedInsurers.includes(option.insurer_name);

														return (
															<>
															<div
																key={index}
																onClick={() => handleSelectedInsurer(option.insurer_name)}
																style={{
																	border: "1px solid #e4e4e4"
																}}
																className={`d-flex flex-column justify-content-between border-radius-8 rounded-lg cursor-pointer transition-all ${
																	isSelected
																		? "border-blue-500"
																		: "border-gray-200 hover:border-blue-300"
																}`}
															>
																<div className="flex items-center space-x-2">
																	<input
																		type="checkbox"
																		checked={isSelected}
																		readOnly
																		className="checkbox"
																	/>
																</div>

																<div className="insurer-card d-flex justify-content-center align-items-center 100-h my-2">
																	<img
																		src={option.insurer_logo}
																		alt={option.insurer_name}
																		style={{ width: option.width, height: option.height }}
																	/>
																</div>

																<div className="flex justify-content-end space-x-2">
																	<span 
																	style={{
																		borderRadius: "8px 0 6px 0"
																	}}
																	className={`text-span px-2 font-medium
																		${
																			isSelected 
																				? "text-white bgPrimary"
																				: "text-gray-600 bg-gray-100" 
																		}
																	`}>
																		{option.insurer_name}
																	</span>
																</div>
															</div>
															</>
														);
													})}
												</div>
											</div>
										</div>
										<Button
											className="btn-primary"
											label={t(`common.requestQuote`)}
											onClick={submitMoreQuotes}
										/>
									</>
								)}
							></Dialog>

							{/* Sticky Bottom Section */}
							{plan && hasAppSession && !sessionExpired && (
								<div
									className="sticky-bottom"
									style={{ display: isModalVisible ? "none" : "block" }}
									ref={(el) => {
										if (el) {
											console.log(el.offsetHeight);

											setOffsetHeight(el.offsetHeight);
										}
									}}
								>
									<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
										<div className="plan-details w-50">
											<span className="text-left formatted-text">{`Selected Plan for`}</span>
											<p className="my-0 fw-bold insurer-name">
												{getInsurerName(plan.insurer_name)}
											</p>
										</div>
										<div className="col-sm-6 w-50">
											<Image
												width="100%"
												height="auto"
												src={plan.image_url}
												alt={plan.insurer_name}
												style={{
													maxWidth: [
														"GENERALI",
														"BERJAYA SOMPO",
														"TOKIO MARINE",
														"TAKAFUL IKHLAS",
														"TUNE PROTECT",
													].includes(plan.insurer_name)
														? "110px"
														: "150px",
													height: "auto",
													display: "block",
													margin: "0 auto",
												}}
											/>
										</div>
									</div>
									<hr />
									<div className="d-flex flex-row flex-wrap justify-content-between align-items-center py-2">
										<div className="w-100">
											{parseFloat(plan?.basic_premium) >
											parseFloat(plan?.gross_premium) ? (
												<>
													<span className="fs-xl fw-bold">
														{`RM ${
															new Intl.NumberFormat("en-US", {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															}).format(plan?.gross_premium || 0) || ""
														}`}
													</span>
													<span>{" / after discount"}</span>
													<p className="original-price color-primary">
														<s>{`RM ${
															new Intl.NumberFormat("en-US", {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															}).format(plan?.basic_premium || 0) || ""
														}`}</s>
													</p>
												</>
											) : (
												<>
													<span className="fs-xl fw-bold">
														{`RM ${
															new Intl.NumberFormat("en-US", {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															}).format(plan?.gross_premium || 0) || ""
														}`}
													</span>
												</>
											)}
										</div>
									</div>
									<Button
										label="Proceed (2/5)"
										className="btn-primary"
										onClick={(e) => submitSelectedPlan(e)}
									/>
									{/* BottomMessagePopUp Component */}
									<BottomMessagePopUp
										message={errorMessage}
										type="error"
										isVisible={isErrorVisible}
										onClose={() => setIsErrorVisible(false)}
									/>
								</div>
							)}
						</div>
					</div>
				</div>

				{/*isSuccessModalVisible && (
					<Dialog
						className="filter-modal d-flex flex-row bg-white p-20 gap-2"
						modal
						header={`Pop up`}
						visible={isSuccessModalVisible}
						style={{
							borderRadius: "24px",
							margin: 0,
							width: "90%",
							overflowY: "auto",
						}}
						position={"center"}
						onHide={() => setIsSuccessModalVisible(false)}
						content={({ hide }) => (
							<>
								<div className="filters w-100">
									<div className="d-flex justify-content-between mb-2">
										<div
											className="get-quote-image-section"
											style={{ height: "150px" }}
										>
											<img
												className="get-quote-banner"
												src={prettyGirlCS}
												alt="get-quote-banner"
												loading="lazy"
												style={{
													maxWidth: "100%",
													height: "auto",
													objectFit: "contain",
													height: "150px",
												}}
											/>
										</div>
										<div>
											<p className="fs-lg color-heading fw-medium text-center">{`Our services are available promptly all year round.`}</p>
											<p className="formatted-text text-center">{`You will receive your quotations within minutes via the ANSA app.`}</p>
										</div>

										<Button
											className="btn-primary"
											label="Confirm"
											onClick={(e) => submitMoreQuotes(e)}
										/>
										<p className="color-primary text-center">{`We are committed to serving you better, kindly allow us some time to get back to you.`}</p>
									</div>
								</div>
							</>
						)}
					></Dialog>
				)*/}

				<Dialog
					className="filter-modal d-flex flex-row bg-white p-4 gap-2"
					modal
					header={`Filters`}
					visible={dialogOpen}
					style={{
						borderRadius: "24px 24px 0 0",
						margin: 0,
						width: "100vw",
						overflowY: "auto",
					}}
					position={"bottom"}
					content={({ hide }) => (
						<>
							<div className="filters d-flex justify-content-center w-100">
								<Image className="mr-2" src={image} height={80} width={80} />
								<div className="d-flex flex-row justify-content-center mb-2">
									<h2 className="text-center m-2">{dialogTitle}</h2>
									<span 
										dangerouslySetInnerHTML={{
											__html: respMessage.replace(/\n/g, "<br />"),
										}}
										className="formatted-text text-center">
									</span>
								</div>
								<div className="d-flex flex-row align-items-end justify-content-between p-2 pt-3 pb-0 mb-2 border-radius-14 bg-blue-50">
									<img
										src={serviceCallerFemale}
										alt="success-resp"
										loading="lazy"
										style={{
											objectFit: "contain",
											width: "25%",
											height: "auto"
										}}
									/>
									<div 
										className="d-flex flex-column justify-content-between"
										style={{
											width: "70%"
										}}
									>
										<p 
											className="color-heading fw-medium text-left m-0"
											style={{
												fontSize: "14px",
												lineHeight: "16px"
											}}
										>
											{t(`autoInsurance.selectCarPlan.servicesAreAvailable`)}
										</p>
										<p 
											className="color-primary fw-bold text-left m-0 pb-3"
											style={{
												fontSize: "12px",
												lineHeight: "14px"
											}}
										>
											{t(
												`autoInsurance.selectCarPlan.youWillReceiveTheQuotationsWithinMinutes`
											)}
										</p>
									</div>
								</div>
							</div>
							<Button
								className="btn-primary fw-bold"
								label={`View My Request`}
								onClick={(e) => viewMyRequest(e)}
							/>
							<Button
								className="btn-secondary fw-bold"
								label={`Back to Home`}
								onClick={(e) => handleBackButton(e)}
							/>
						</>
					)}
				></Dialog>
			</div>
			{loader2 && <Loader2 />}
		</>
	);
};

export default SelectCarPlan;
